// src/webideal-recruit/components/dashboard/RecentActivity.jsx
import React from "react";
import { motion } from "framer-motion";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import { Badge } from "@/components/ui/badge";
import { format } from "date-fns";

const stageColors = {
  interview: "bg-indigo-100 text-indigo-700",
  technical: "bg-blue-100 text-blue-700",
  screening: "bg-amber-100 text-amber-700",
  new: "bg-slate-100 text-slate-700",
};

export default function RecentActivity({ applications, candidates, jobs }) {
  const getCandidate = (id) => candidates.find((c) => c.id === id);
  const getJob = (id) => jobs.find((j) => j.id === id);

  return (
    <div className="bg-white border border-slate-200 rounded-xl shadow-sm overflow-hidden">
      <div className="p-6 border-b border-slate-200">
        <h3 className="text-lg font-semibold text-slate-900">Recent Applications</h3>
        <p className="text-sm text-slate-500">Latest candidate activity</p>
      </div>

      <div>
        {applications.slice(0, 5).map((app, index) => {
          const candidate = getCandidate(app.candidate_id);
          const job = getJob(app.job_id);
          if (!candidate || !job) return null;

          const initials = candidate.full_name
            ?.split(" ")
            .map((s) => s[0])
            .join("")
            .toUpperCase();

          return (
            <motion.div
              key={app.id}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: index * 0.05 }}
              className="flex items-center gap-4 p-4 hover:bg-slate-50 transition"
            >
              <Avatar className="h-11 w-11">
                <AvatarFallback className="bg-indigo-600 text-white">
                  {initials}
                </AvatarFallback>
              </Avatar>

              <div className="flex-1">
                <p className="font-medium text-slate-900">{candidate.full_name}</p>
                <p className="text-xs text-slate-500">Applied for {job.title}</p>
              </div>

              <div className="flex flex-col items-end gap-1">
                <Badge className={stageColors[app.stage] || "bg-slate-100"}>
                  {app.stage}
                </Badge>
                <p className="text-xs text-slate-400">
                  {format(new Date(app.created_date), "MMM d")}
                </p>
              </div>
            </motion.div>
          );
        })}
      </div>
    </div>
  );
}
